export default __webpack_public_path__ + "static/media/back pic.104d45d2.svg";